import { Filters } from 'features/Filters/types/Filters';

export const getOptionsForFilter = (filter: string, filterOptions: Filters) => {
  return filterOptions[filter as keyof Filters];
};
